module.exports = __webpack_public_path__ + "img/no_notifications.92f0b7a5.png";